var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('p',{staticClass:"small font-weight-bold text-gray-400 mb-0",domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }